<template>
	<div class="layout">
		<div class="layout__header">
			<div class="layout__title">
				<h3>
					Pago dominical
				</h3>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12">
				<textarea-field placeholder="Escriba una observación" id="observaciones"
					v-model="modelValue.observacion_dominical">
					<span>Observaciones</span>
					<span v-if="errores.observacion_dominical" class="helper-text text-danger" slot="helper">
						<strong>{{ errores.observacion_dominical[0] }}</strong>
					</span>
				</textarea-field>
			</div>
			<div class="col-xs-12 col-md-6">
				<div class="form-field">
					<div class="datepicker-field">
						<VueCtkDateTimePicker id="fecha_proximo_pago" v-model="modelValue.fecha_proximo_pago" locale="es" no-label only-date
						button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD" label="Seleccione una fecha..." noClearButton
						:disabled-weekly="[0]" />
						<label>Generar recibo pago adelantado</label>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-buttons">
			<button class="btn-success" @click="guardar">
				<i class="fa fa-save"></i><span>Guardar</span>
			</button>
			<button class="btn-danger btn--text" @click="$emit('cerrar')">
				<i class="fa fa-times"></i><span>Cancelar</span>
			</button>
		</div>
	</div>
</template>
  
<script>
export default {
	props: {
		value: {
			required: false,
			type: Object,
			default: function () {
				return {};
			},
		},
		errores: {
			required: false,
			type: Object,
			default: function () {
				return {};
			},
		}
	},
	data: function () {
		return {
			modelValue: this.value
		};
	},
	methods: {
		guardar: function () {
			swal({
				title: "¿Desea guardar?",
				text: "Se requiere confirmación",
				icon: "question",
				showCancelButton: true,
				confirmButtonText: "Aceptar",
				cancelButtonText: "Cancelar",
			}).then((result) => {
				if (result.value) {
					this.$emit("input", this.modelValue)
				}
			});
		},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/prestamos/cobros/ObservacionDominical.vue